// style-utils.js
import { css } from 'styled-components'

export const gradient = {
  background: (angle, startColor, stopColor, startPos = '0%', endPos = '100%') => css`
    background: linear-gradient(${ css(...angle)}, ${css(startColor)} ${startPos}, ${css(stopColor)} ${endPos});
  `
}


// WEBPACK FOOTER //
// ./src/helpers/styleUtils.js